import routes from "../const/routes";

/**
 * Get bring new creators link
 * @param {Object} params
 * @param {string} params.newCreatorReferralCode
 * @returns Bring new creators link
 */
export const getBringNewCreatorsLink = ({ newCreatorReferralCode }) =>
  `${window.location.origin}${routes.CREATORS()}${newCreatorReferralCode}`;

/**
 * Get creator profile link
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.referralCode
 * @param {boolean} params.isMyProfile
 * @returns Creator profile link
 */
export const getProfileShareLink = ({ username, referralCode, isMyProfile }) =>
  isMyProfile || !referralCode
    ? `${window.location.origin}${routes.CREATOR_PROFILE()}${username}`
    : `${window.location.origin}${routes.CREATOR_PROFILE()}${username}?ref=${referralCode}`;

/**
 * Get creator link w/ post
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.postUniqueKey
 * @param {string} params.referralCode
 * @returns Creator profile link w/ selected post
 */
export const getPostShareLink = ({ username, postUniqueKey, referralCode }) => {
  let link = `${window.location.origin}${routes.CREATOR_PROFILE()}${username}?view=${postUniqueKey}`;
  if (referralCode) link += `&ref=${referralCode}`;
  return link;
};

/**
 * Get creator link w/ subscription
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.subscriptionUniqueKey
 * @param {string} params.referralCode
 * @returns Creator profile link w/ selected subscription
 */
export const getSubscriptionShareLink = ({
  username,
  subscriptionUniqueKey,
  referralCode,
}) => {
  let link = `${window.location.origin}${routes.CREATOR_PROFILE()}${username}?sub=${subscriptionUniqueKey}`;
  if (referralCode) link += `&ref=${referralCode}`;
  return link;
};

/**
 * Copy text to clipboard
 * @param {string} text
 * @returns
 */
export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

/**
 * Get telegram share link
 * @param {string} url Absolute URL to share, e.g. "https://example.com/path/to/article?with=params"
 * @param {string} text Optional comment to share URL with, e.g. "Check out this article!"
 * @return {string} Telegram share link
 */
export const getTelegramShareLink = (url, text = "") =>
  `https://t.me/share/url?url=${url}&text=${text}`;

/**
 * Get Twitter share link
 * @param {string} url Absolute URL to share, e.g. "https://example.com/path/to/article?with=params"
 * @param {string} text Optional comment to share URL with, e.g. "Check out this article!"
 * @return {string} Twitter share link
 */
export const getTwitterShareLink = (url, text = "") =>
  `https://twitter.com/intent/tweet?text=${text}&url=${url}`;

/**
 * Get Facebook share link
 * @param {string} url Absolute URL to share, e.g. "https://example.com/path/to/article?with=params"
 * @param {string} text Optional comment to share URL with, e.g. "Check out this article!"
 * @returns Facebook share link
 */
export const getFacebookShareLink = (url, text = "") => {
  return `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`;
};

/**
 * Get WhatsApp share link
 * @param {string} url Absolute URL to share, e.g. "https://example.com/path/to/article?with=params"
 * @param {string} text Optional comment to share URL with, e.g. "Check out this article!"
 * @returns WhatsApp share link
 */
export const getWhatsAppShareLink = (url, text) =>
  `https://api.whatsapp.com/send?text=${text} ${url}`;

/**
 * Open link in popup
 * @param {String} url
 */
export const openInPopup = (url) =>
  window.open(url, "popup", "width=600,height=600");

/**
 * Open link in popup
 * @param {MouseEvent} event
 */
export const openInPopupByEvent = (event) => openInPopup(event.target?.href);

/**
 * Get livestream link
 * @param {Object} params
 * @param {string} params.streamUniqueKey
 * @returns Livestream link w/ selected post
 */
export const getLivestreamShareLink = ({
  streamUniqueKey,
  referralCode,
  contentOwnerKey,
}) => {
  return referralCode && contentOwnerKey
    ? `${window.location.origin}${routes.STREAM()}/${streamUniqueKey}?ref=${referralCode}&contentOwnerKey=${contentOwnerKey}`
    : `${window.location.origin}${routes.STREAM()}/${streamUniqueKey}`;
};

/**
 * Get content request link
 * @returns link w/ content request
 */

//todo in future make ID logic dynamic
export const getContentRequestLink = ({ username }) => {
  return `${window.location.origin}${routes.CONTENT_REQUEST()}/${username}`;
};

/**
 * Get creator link w/ stream
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.streamUniqueKey
 * @param {string} params.referralCode
 * @param {string} params.contentOwnerKey
 * @returns Creator profile link w/ selected stream
 */
export const getStreamDetailsShareLink = ({
  username,
  streamUniqueKey,
  referralCode,
  contentOwnerKey,
}) => {
  let link = `${window.location.origin}${routes.CREATOR_PROFILE()}${username}?stream=${streamUniqueKey}`;
  if (referralCode && contentOwnerKey)
    link += `&ref=${referralCode}&contentOwnerKey=${contentOwnerKey}`;
  return link;
};

export const shareFunctionsMap = {
  post: getPostShareLink,
  profile: getProfileShareLink,
  subscription: getSubscriptionShareLink,
  bringNewCreator: getBringNewCreatorsLink,
  stream: getLivestreamShareLink,
  contentRequest: getContentRequestLink,
  streamDetails: getStreamDetailsShareLink,
};
